import { contactUsConstants } from '../constants';
import { constants } from '../../Constants';

const initialstate = {
	message: '',
	responseType: '',
};
export function contactUs(state = initialstate, action) {
	switch (action.type) {
		case contactUsConstants.CONTACTUS_SUCCESS:
			return {
				...state,
				message: constants.CONTACT_US_SUCCESS_MSG,
				responseType: constants.SUCCESS_TEXT,
				loadingResponse: false
			};
		case contactUsConstants.CONTACTUS_FAILURE:
			return {
				...state,
				message: action.err, 
				responseType: constants.ERROR_TEXT,
				loadingResponse: false
			};
		case contactUsConstants.CONTACTUS_REQUEST:
			return {
				...state,
				message: '',
				responseType: '',
				loadingResponse: true
			};
		case contactUsConstants.CONTACTUS_CLEAR:
			return {
				...state,
				message: '',
				responseType: '',
			};
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/store/reducers/contactUs.reducer.js